<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         :viewBox="viewBox"
         :aria-labelledby="iconName"
         role="presentation"
    >
        <title
                :id="iconName"
                lang="en"
        >{{ iconAlt }}</title>
    <g :fill="iconColor">
      <slot />
    </g>
  </svg>
</template>

<script>
    export default {
        props: {
          iconName: {
            type: String,
            default: 'box'
          },
          iconAlt: {
            type: String,
            default: ''
          },
            width: {
                type: [Number, String],
                default: 24
            },
            height: {
                type: [Number, String],
                default: 24
            },
            viewBox: {
                type: String,
                default: '0 0 24 24'
            },
            iconColor: {
                type: String,
                default: 'currentColor'
            }
        }
    }
</script>

<style lang="sass" scoped>
    svg
        display: inline-block
        vertical-align: baseline
        margin-bottom: -4px

        path
            fill: $dark
</style>